import { render, staticRenderFns } from "./FAQPartnership.vue?vue&type=template&id=35de4bae"
import script from "./FAQPartnership.vue?vue&type=script&lang=js"
export * from "./FAQPartnership.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports